import makeStyles from "@material-ui/core/styles/makeStyles";

export default makeStyles(theme => ({
  date: {
    color: theme.palette.secondary.tint40
  },
  emptyText: {
    textAlign: "center"
  },
  // coinLogo: {
  //   [theme.breakpoints.down("xs")]: {
  //     display: "none"
  //   }
  // },
  coinNameAndIcon: {
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center"
  },
  coinTitle: {
    color: theme.palette.secondary.tint40,
    marginLeft: theme.spacing(3),
    [theme.breakpoints.down("sm")]: {
      display: "none"
    }
  },
  currencyName: {
    marginLeft: theme.spacing(7)
  },
  coinLogoAndText: {
    display: "flex",
    alignItems: "center"
  },
  inlineBlock: {
    display: "inline-block"
  },
  wrapperLastCol: {
    display: "flex",
    minWidth: "150px",
    alignItems: "center",
    justifyContent: "space-evenly",
    // width: "80%",
    marginLeft: "5px",
    marginRight: "5px",
    [theme.breakpoints.down("sm")]: {
      width: "100%",
      marginLeft: "5px",
      marginRight: "5px"
    }
  },

  bagBtn: {
    color: theme.palette.secondary.tint40,
    fontSize: theme.fontSize["20"],
    padding: theme.spacing(4),
    borderRadius: theme.spacing(4),
    backgroundColor: theme.palette.background.main,
    transition: ".1s ease-in",
    "&:hover": {
      backgroundColor: theme.palette.error.main,
      color: "white"
    }
  },

  plusBtn: {
    color: theme.palette.secondary.tint40,
    fontSize: theme.fontSize["20"],
    padding: theme.spacing(4),
    borderRadius: theme.spacing(4),
    backgroundColor: theme.palette.background.main,
    transition: ".1s ease-in",
    "&:hover": {
      backgroundColor: theme.palette.primary.main,
      color: "white"
    }
  },
  cashOutBtn: {
    color: theme.palette.secondary.tint40,
    fontSize: theme.fontSize["20"],
    padding: theme.spacing(4),
    borderRadius: theme.spacing(4),
    backgroundColor: theme.palette.background.main,
    transition: ".1s ease-in",
    "&:hover": {
      backgroundColor: theme.palette.red2.tint12,
      color: theme.palette.red.main
    }
  }
}));
